module.exports = __webpack_public_path__ + "img/reference34.34545489.jpg";